import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=3402c737&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=ts&"
export * from "./DonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=3402c737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402c737",
  null
  
)

export default component.exports